import { useFeatureFlagsStore } from '@/stores/useFeatureFlags';
import { useUserDetailsStore } from '@/stores/useUserDetails';
import { featureFlagSlugs } from '@/constants/featureFlagSlugs';

export default defineNuxtRouteMiddleware(async (to, from) => {
  /**
   * This check prevents `/authenticate` from being called twice
   */
  if (
    to.fullPath === '/check-email' ||
    to.fullPath === '/logout' ||
    to.fullPath === '/open-in-browser' ||
    to.query?.code ||
    to.hash
  ) {
    return;
  }

  const featureFlagsStore = useFeatureFlagsStore();
  const userDetailsStore = useUserDetailsStore();

  const isMagicLinkLoginEnabled = featureFlagsStore.getByFlagName(
    featureFlagSlugs.transportMagicLinkLogin,
  );

  if (isMagicLinkLoginEnabled) {
    await userDetailsStore.getAuthenticatedUserDetails();
  } else {
    await userDetailsStore.getUserDetails();
  }
});
